/* === React Elements === */
import React from "react";

const Ampersand = () => {

    return (
        <>
            <a id="ampersand"></a>
            <div class="stnd-padding full-height flex column al-center just-center">
                <div class="red-border border-radius text-padding text-width">
                    <h1 className="bright-red no-space">&</h1>
                    <h1 className="bright-red sub-title no-space">Mother of Microbes</h1>
                    {/* <div className="flex just-center">
                        <img className="portrait " src="./Images/ampersand-portrait.JPG" />
                        <div className="relative flex flex-end">
                            <h2 className="big-ampersand white absolute">&amp;</h2>
                        </div>
                    </div> */}
                    <p>Ampersand Paris is an interdisciplinary performing artist and fermentation revivalist. They are the founder of FAILSPACE and design partner at FAILSPACE Design Services. Their current practice is a fermentation CSA that sustainably feeds community while cultivating a trans-microbiopolitic for making and being. They concern themselves with taking care of nearly invisible things: bacteria, yeast, lines of code, and the liminal space of trans existence. Their overlapping processes of fermentation, decomposition, self-portraiture, computer programming, and performance improvisation build relationships to these invisible forces and illuminate their world-shaping impacts. Their desire is to learn the technologies of the small in order to care for big transformations necessary to survive, if not effervesce, in climate ruin.</p>
                </div>
            </div>
        </>
    )
}

export default Ampersand;